import React from "react";
import Modal, { ModalButton } from "common/modal";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const ModalInfo = styled.div`
  text-align: left;
  font-size: 12px;
  color: #1070b6;
  font-weight: bold;
`;

const ModalText = styled.div`
  margin: 8px 0px 12px;
  font-size: 18px;
  color: #282828;
`;

interface SkipTopicModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const SkipTopicModal = (props: SkipTopicModalProps) => {
  const { t } = useTranslation("class_details");
  const { onConfirm, onCancel } = props;

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Modal title={t("SKIP TOPIC")} {...props}>
      <ModalText>
        {t(
          "Are you sure you want to skip this topic? It will not appear in your class searches and recommended classes anymore."
        )}
      </ModalText>
      <ModalInfo>{t("Note: You can undo this at any time.")}</ModalInfo>

      <br />

      <ModalButton onClick={() => onConfirm()}>{t("SKIP IT")}</ModalButton>
      <ModalButton onClick={() => onCancel()}>{t("DO NOT SKIP")}</ModalButton>
    </Modal>
  );
};

export default SkipTopicModal;
